import { useEffect, useState } from 'react';
import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";

// Get Live Updates

// const requestOptions = {
//     method: "GET",
//     headers: {
//         "Content-Type": "application/json",
//     }
// }

export const Time = ({ onEasterEgg }) => {
    const [time, setTime] = useState(null);
    const [clickCount, setClickCount] = useState(0);
    const [resetTimer, setResetTimer] = useState(null);
    
    useEffect(() => {
        // Time endpoint doesn't require authentication - use simple fetch
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const getTime = async () => {
            try {
                const res = await fetch('/live/time', requestOptions);
                const data = await res.json();
                setTime(data.time);
            } catch (err) {
                logger.log(err);
            }
        };

        // Call the function immediately when the component mounts
        getTime();

        // Call the function every 5 seconds
        const intervalId = setInterval(getTime, 10000);
        
        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);

    // Handle time display clicks for Easter egg
    const handleTimeClick = (e) => {
        e.preventDefault();
        
        // Clear existing reset timer
        if (resetTimer) {
            clearTimeout(resetTimer);
        }
        
        const newClickCount = clickCount + 1;
        setClickCount(newClickCount);
        
        // Trigger Easter egg on 5 clicks
        if (newClickCount >= 5) {
            setClickCount(0); // Reset counter
            if (onEasterEgg) {
                onEasterEgg();
            }
        } else {
            // Reset click count after 3 seconds of no clicks
            const timer = setTimeout(() => {
                setClickCount(0);
            }, 3000);
            setResetTimer(timer);
        }
    };

    return (
        <span 
            onClick={handleTimeClick}
        >
            {time}
        </span>
    );
};

export const Day=() => {
        
    const [day, setDay] = useState(null);
    
    useEffect(() => {

        const sessionToken =  getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const getDay = async () => {
            try {
                const res = await fetch('/live/day', requestOptions);
                const data = await res.json();
                setDay(data.day);
            } catch (err) {
                logger.log(err);
            }
        };

        // Call the function immediately when the component mounts
        getDay();

        // Call the function every 5 seconds
        const intervalId = setInterval(getDay, 60000);

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);

    return day;
}


